import React from 'react'
import debounce from 'lodash.debounce'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import colors from '../../utils/colors'
import { FormDashboardInput, FormDashboardTextarea } from '../dashboard-form'
import { Button } from '../buttons'
import { errorHandler, useViewport } from '../../utils'
import apiService from '../../features/api/service'
import { useInternationalization } from '../../features/i18n'

const buttonText = {
  en: 'Submit Your Testimony',
  id: 'Kirim Testimoni Anda'
}

const FormPopupContent = ({setSubmitted, fetcher, apiKey, singleStateKey, type, ...props}) => {
  const dispatch = useDispatch()
  const { isMobile } = useViewport()
  const [name, setName] = React.useState('')
  const [message, setMessage] = React.useState('')
  const id = useSelector(state => state[singleStateKey].data.id)
  const [requesting, setRequesting] = React.useState(false)
  const { translate } = useInternationalization()

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      if(e.target.name === 'name'){
        setName(e.target.value)
      } else {
        setMessage(e.target.value)
      }
    }
  }, 250)

  const handleSubmit = () => {
    if(message && id){
      let requestBody = {}
      if(type === 'nonUser'){
        requestBody = {
          "testimoniNonUser": {
            "nama": name,
            "deskripsi": message
          }
        }
      } else if(type === 'user') {
        requestBody = {
          "testimoniUser": {
            "deskripsi": message
          }
        }
      }

      console.log(requestBody)

      setRequesting(true)

      apiService.update(apiKey, id, requestBody)
        .then(res => {
          if(res.message){
            // Unnecessary filter for API response message. Remove this after fixed wording applied.
            if(res.message === "you already give testimoni this content"){
              toast.info("You have already given testimony to this content.")
            } else {
              toast.info(res.message)
            }
          }

          setSubmitted(true)
          dispatch(fetcher(id))
        })
        .catch(err => {
          const msg = errorHandler(err)
          toast.error(msg)
        })
        .finally(() => {
          setRequesting(false)
        })
    }
  }

  return (
    <div>
      <p className="text-lg lg:text-2xl font-bold mb-4 lg:mb-10">Add Your Testimony</p>
      {
        type === 'nonUser' &&
        <div className="text-gray-444 text-sm mb-5 lg:mb-8">
          <FormDashboardInput
            className="w-full"
            name="name"
            placeholder={translate('GENERAL', 'name')}
            onChange={e => {e.persist(); handleInput(e)}}
          />
        </div>
      }
      <div className="text-gray-444 text-sm mb-5 lg:mb-8">
        <FormDashboardTextarea
          className="w-full"
          placeholder="Message"
          onChange={e => {e.persist(); handleInput(e)}}
        />
      </div>
      <div onClick={handleSubmit} className="lg:inline-block">
        <Button
          disabled={requesting}
          isLoading={requesting}
          className="lg:inline-block lg:px-16"
          thin={isMobile}
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

const ConfirmationContent = () => {
  return (
    <div>
      <p className="text-lg lg:text-2xl font-bold mb-5 lg:mb-10">Thank You</p>
      <p className="text-sm text-gray-444">Testimony dalam masa moderasi. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”</p>
    </div>
  )
}

const TestimoniAdder = ({ fetcher, apiKey, singleStateKey, type }) => {
  const [show, setShow] = React.useState(false)
  const [submitted, setSubmitted] = React.useState(false)
  const { language } = useSelector(state => state.system)

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setShow(false)
  }

  return (
    <div>
      <div
        className="block lg:inline-block rounded border-2 font-accent font-bold text-primary text-xs text-center lg:px-6 py-2 lg:py-4 cursor-pointer uppercase"
        style={{borderColor: colors.primary}}
        onClick={() => setShow(true)}
      >
        {buttonText[language.name]}
      </div>

      {/* Popup */}
      {
        show &&
        <div
          className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
          style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
          onClick={handleClose}
        >
          <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
            <div className="lg:w-10/12 mx-auto p-5 lg:p-20 bg-white rounded overflow-y-auto" style={{maxHeight: '100vh'}}>

              {
                !submitted &&
                <FormPopupContent
                  fetcher={fetcher}
                  setSubmitted={setSubmitted}
                  apiKey={apiKey}
                  singleStateKey={singleStateKey}
                  type={type}
                />
              }

              {
                submitted &&
                <ConfirmationContent />
              }

            </div>
          </div>
        </div>
      }
    </div>
  )
}

export { TestimoniAdder }
